/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tab_OverviewInputs */

const en_project_tab_overview = /** @type {(inputs: Project_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const nl_project_tab_overview = /** @type {(inputs: Project_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Project_Tab_OverviewInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_tab_overview = /** @type {((inputs?: Project_Tab_OverviewInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tab_OverviewInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_project_tab_overview(inputs)
	return en_project_tab_overview(inputs)
});